const translations = {
  "en": {
    "Binding failed, the number of bindable wallets has exceeded": "Binding failed, the number of bindable wallets has exceeded",
    "Binding failed，Please try again.": "Binding failed，Please try again.",
    "Binding failed，This wallet is already linked to another account.": "Binding failed，This wallet is already linked to another account.",
    "This wallet has been bound": "This wallet has been bound",
    "Wallet connected successfully!": "Wallet connected successfully!",
    "Wallet rejected.Please try again..": "Wallet rejected.Please try again.."
  },
  "zh-tw": {
    "Binding failed, the number of bindable wallets has exceeded": "綁定失敗，可綁定的錢包數量已達上限。",
    "Binding failed，Please try again.": "綁定失敗，請重試。",
    "Binding failed，This wallet is already linked to another account.": "綁定失敗，該錢包已綁定至其他帳戶。",
    "This wallet has been bound": "該錢包已被綁定。",
    "Wallet connected successfully!": "錢包連線成功！",
    "Wallet rejected.Please try again..": "錢包連線請求已拒絕，請重試。"
  }
};

export default translations;
